export { default, getServerSideProps } from '@views/catalog/[category]';
